import { createContext } from 'react';
import { container } from '../../../diContainer';
import { IDatasetsService } from './datasets.service';
import { IDatasetsStore } from './datasets.store';

export interface IDatasetsContext {
  service: IDatasetsService;
  store: IDatasetsStore;
}

export const Datasets = createContext<IDatasetsContext>(undefined);

export function makeDatasetsContext(): IDatasetsContext {
  const service = container.get(IDatasetsService.$);
  const ctx: IDatasetsContext = {
    service,
    store: service.store,
  };

  return ctx;
}
